import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { Icon, Text, TextButton } from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import { useProductDetails } from 'journey/productDetails/provider';
import { ProductDetailsActionTypes } from 'journey/productDetails/reducer/productDetails.reducer';
import { InfoLayerStatus } from 'journey/productDetails/typings';

const InlineIcon = styled(Icon)`
  ${({ theme: { spacing } }) => css`
    position: relative;
    display: inline-block;
    top: 6px;
    margin-right: ${spacing.s1};
  `}
`;

const DeliveryOptionsInformation = () => {
  const { dispatch } = useProductDetails();
  const { palette } = useTheme();

  const handleClick = (contentKey: string, customLink: string) => {
    dispatch({
      type: ProductDetailsActionTypes.SetInfoLayer,
      infoLayer: {
        contentKey,
        status: InfoLayerStatus.RawHtml,
        isNested: false,
      },
    });
    trackCustomLink(customLink);
  };

  return (
    <LinkRegion regionId="deliveryInfo">
      <Text variant="bodySMedium" mb="s2">
        <InlineIcon name="cart_small" />
        Free delivery available
        <TextButton
          title="Free delivery available Information icon"
          type="button"
          variant="textbutton"
          onClick={() => {
            handleClick(
              'productDetails.freeDelivery',
              'Free delivery available Information icon',
            );
          }}
        >
          <InlineIcon name="info_small" fill={palette.baseColors.lupin} />
        </TextButton>
      </Text>
      <Text variant="bodySMedium">
        <InlineIcon name="pin_small" />
        Click & Collect available
        <TextButton
          title="Click & Collect available Information icon"
          type="button"
          variant="textbutton"
          onClick={() => {
            handleClick(
              'productDetails.clickAndCollect',
              'Click & Collect available Information icon',
            );
          }}
        >
          <InlineIcon name="info_small" fill={palette.baseColors.lupin} />
        </TextButton>
      </Text>
    </LinkRegion>
  );
};

export default DeliveryOptionsInformation;
